import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CheckoutActions } from '../store/actions/';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class PickupFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  setShop(id: string): void {
    this.store.dispatch(new CheckoutActions.SetShop(id));
  }

  resetShop(): void {
    this.store.dispatch(new CheckoutActions.ResetShop());
  }

  getActiveShopId(): Observable<string | undefined> {
    return this.store.pipe(select(CheckoutSelectors.getActivePickup));
  }
}
